var url = 'http://www.google.ca';
console.log("https://canada-cleckinc.myshopify.com/admin/themes/2399436823?key=assets/custom.js");
/*
function getQueryVariable(variable)
{
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  console.dir( vars );
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    console.dir( pair );
    if(pair[0] == variable){
      return pair[1];}
  }
  return false;
}

var queryVariable = getQueryVariable("url");
if( queryVariable !== false ) {
  alert('going back to... ' + queryVariable)
  window.location.href = 'https://'+queryVariable;
} else {
  console.log('not going anywhere! SORRY');
}
window.location.href = url;
*/